import { Auth } from "aws-amplify";
import React,{ useState, useContext } from "react";
import { VerificationCodeForResetPassword } from "./VerificationCodeForResetPassword";
import {PageContext} from '../../PageContext';
import {PAGE} from "../../constants"

export function ForgotPassword() {

    const [email,setEmail] = useState("");
    const [isCodeSent,setIsCodeSent] = useState(false);
    const [formError,setFormError] = useState("");
    const {page, setPage} = useContext(PageContext);


    async function handleOnSubmit(event) {
        console.log("onSubmit")
        event.preventDefault();
        await Auth.forgotPassword(email)
            .then((data)=>{
                setIsCodeSent(true);
                console.log(data);
            })
            .catch(err => {
                console.error(err.message);
                setFormError(err.message);
                // throw err;
            });
    }
    
    if(isCodeSent){
        return (
            <VerificationCodeForResetPassword email={email}/>
        );
    }
    
    
    return (
        <div className="topcontainer-signup">
            
                <div >
                    <form onSubmit={handleOnSubmit}>
                        <h1>Forgot Password?</h1>
                        <h4>You can reset your password here</h4>
                        {formError && <p style={{color:"red"}}>{formError}</p>}

                        <hr />
                        <input type="text" name="email" value={email} onChange={(event) => setEmail(event.target.value)} className="ipt ipc" placeholder="Email Address" required />

                        <div className="clearfix">
                            <button type="submit" className="ips ipc">Reset Password</button>
                            <a href="" onClick={(e)=>{e.preventDefault();setPage(PAGE.LOGIN)}}>Back to Login</a>
                        </div>
                    </form>
                </div>

           

        </div>
    );
}